import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Error from './pages/Error';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/whatsapp';
import CitySelector from './pages/CitySelector';
import './App.css';

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedCity, setSelectedCity] = useState('');
  const [isCitySelected, setIsCitySelected] = useState(false);

  const handleCitySelect = (city) => {
    setSelectedCity(city);
    setIsCitySelected(true);
    navigate('/');
  };

  const showMainApp = isCitySelected || location.pathname === '/home';

  return (
    <>
      {!showMainApp ? (
        <CitySelector onSelectCity={handleCitySelect} />
      ) : (
        <>
          <Header />
          <Routes>
            <Route path="/home" element={<Home selectedCity={selectedCity} />} />
            <Route path="/" element={<Home selectedCity={selectedCity} />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Error />} />
          </Routes>
          <WhatsAppButton />
          <Footer />
        </>
      )}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
